	<template>
	<Modal
		ref="errorModal"
		overlay-type="error"
		:html-classes="['hide--header', 'show--modal']"
		narrow
		:initial-visible="errorStatus"
		@close="onModalClose"
	>
		<div class="overlay-dialog">
			<h2
				class="overlay-dialog__title"
				v-html="errorTitle || title"
			/>
			<div
				class="overlay-dialog__text"
				v-html="errorMessage || message"
			/>
			<div class="overlay-dialog__buttons">
				<Button
					@click.prevent="onModalClose"
					level="primary"
					type="button"
					text="OK"
				/>
			</div>
		</div>
	</Modal>
</template>

<script>
import { mapGetters } from 'vuex'
import Modal from '@/components/Modal'
import Button from '@/components/Button'

export default {
	components: {
		Modal,
		Button,
	},
	props: {
		title: {
			default() {
				return this.$t('forms.errors.error')
			},
		},
		message: {
			default() {
				return this.$t('forms.errors.generic')
			},
		},
	},
	data() {
		return {
		}
	},
	computed: {
		...mapGetters("error", [
			"errorStatus",
			"errorTitle",
			"errorMessage",
		]),
	},
	methods: {
		onModalClose() {
			this.$store.dispatch('error/errorHide');
		}
	},
}
</script>

<style>

</style>